import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import {
    Col,
    Divider,
    Flex,
    Form,
    Layout,
    Modal,
    Row,
    Space,
    Typography,
} from "antd";
import { FormProvider, useForm } from "react-hook-form";
import { useContext, useEffect } from "react";
import { useGetRequestTemplateByIdQuery, useUpdateRequestTemplateMutation } from "../../redux/api/requesttemplate/requesttemplate";
import { RequestTemplateType } from "../../redux/api/requesttemplate/type";
import IncredableButton from "../../components/button";
import RHFTextField from "../../components/RHF/RHFTextField";
import { DocumentRequestResponse } from "../../redux/api/documentrequest/types";
import { SpinnerContext } from "../../context/spinner/spinner";
import { ToastContext } from "../../context/toast/incredable-toast";
import RHFTextArea from "../../components/RHF/RHFTextArea";
import { Header } from "@cloudscape-design/components";

type FormInputType = {
    id: string,
    name: string,
    description: string,
}

export default function EditRequestTemplateModal({
    visible,
    closeModal,
}: {
    visible: boolean;
    closeModal: VoidFunction;
}) {
    const { id } = useParams();
    const spinnerContext = useContext(SpinnerContext);
    const toastContext = useContext(ToastContext);
    const methods = useForm<FormInputType>();
    const { data: template } = useGetRequestTemplateByIdQuery(
        id ? { id } : skipToken
    );
    const [updateRequestTemplate] = useUpdateRequestTemplateMutation()

    useEffect(() => {
        if (template) {
            methods.setValue("name", template?.documentRequestTemplate?.name ?? "");
            methods.setValue("description", template?.documentRequestTemplate?.description ?? "");
        }
    }, [methods, template]);

    return (
        <Modal
            title={<Header>Edit Template</Header>}
            open={visible}
            onOk={methods.handleSubmit(async (data: FormInputType) => {
                spinnerContext?.showSpinner();
                if (!!id)
                    await updateRequestTemplate({
                        id: id,
                        name: data?.name,
                        description: data?.description
                    });
                toastContext?.openInfoNotification({
                    message: `Request template saved successfully`,
                    placement: "topRight",
                });
                spinnerContext?.hidespinner();
                closeModal();
            })}
            onCancel={() => {
                closeModal();
            }}
            okText="Save"
            zIndex={1000}
            centered
        >
            <FormProvider {...methods}>
                <Form name="editrequesttemplate" layout="vertical" autoComplete="off">
                    <Col span={24}>
                        <RHFTextField
                            formItemProps={{
                                label: "Name",
                            }}
                            inputProps={{}}
                            controllerProps={{
                                name: `name`,
                            }}
                            rules={{ required: "This field is required" }}
                        />
                    </Col>
                    <Col span={24}>
                        <RHFTextArea
                            formItemProps={{
                                label: "Description",
                            }}
                            textAreaProps={{}}
                            controllerProps={{
                                name: `description`,
                            }}
                        />
                    </Col>
                </Form>
            </FormProvider>
        </Modal>
    );
}

